


export enum DetailTabsEnum {
	basicOverview = 'basicOverview',
	orderChanges = 'orderChanges',
	customerInfo = 'customerInfo',
	orderHistory = 'orderHistory',
	orderTimeline = 'orderTimeline',
	orderFinance = 'orderFinance',
	orderDocuments = 'orderDocuments',
	orderMedia = 'orderMedia',
	orderSms = 'orderSms',
	exports = 'exports',
}